<template>
  <VueFinalModal
    class="image-lightbox-modal"
    :click-to-close="true"
    :esc-to-close="true"
    :focus-trap="modalFocusTrap"
    overlay-transition="vfm-fade"
    content-transition="vfm-fade"
  >
    <template
      #default="{
        // @ts-ignore - provided by vue-final-modal slot
        close,
      }"
    >
      <div class="image-lightbox-modal__frame" @click.self="close">
        <img
          class="image-lightbox-modal__image"
          :src="resolvedSrc"
          :alt="resolvedFileName || ''"
          draggable="false"
          @click.stop
        />
      </div>
    </template>
  </VueFinalModal>
</template>

<script lang="ts">
import { computed, defineComponent, PropType, Ref, unref } from "vue";
import { VueFinalModal } from "vue-final-modal";

import { modalFocusTrap } from "@/components/modals/focus-trap";

export default defineComponent({
  name: "ImageLightboxModal",
  components: { VueFinalModal },
  props: {
    src: {
      type: [String, Object] as PropType<string | Ref<string>>,
      required: true,
    },
    fileName: {
      type: [String, Object] as PropType<string | null | Ref<string | null>>,
      default: null,
    },
  },
  setup(props) {
    const resolvedSrc = computed(() => unref(props.src));
    const resolvedFileName = computed(() => unref(props.fileName));
    return { modalFocusTrap, resolvedSrc, resolvedFileName };
  },
});
</script>

<style lang="scss">
.image-lightbox-modal {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;

  .vfm__overlay {
    background: rgba(0, 0, 0, 0.6);
  }

  /* Ensure the content wrapper doesn't constrain sizing. */
  .vfm__content {
    background: transparent;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}

.image-lightbox-modal__frame {
  width: 96vw;
  height: 96vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-lightbox-modal__image {
  max-width: 96vw;
  max-height: 96vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0px 12px 48px rgba(0, 0, 0, 0.35);
  user-select: none;
}
</style>
